import {Button, ButtonPriority} from 'wix-ui-tpa';
import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';

export enum CartButtonDataHooks {
  root = 'CartButtonDataHooks.root',
}

export const CartButton = () => {
  const {t} = useTranslation();
  const {navigateToCart} = useControllerProps().navigationStore;

  return (
    <Button
      data-hook={CartButtonDataHooks.root}
      priority={ButtonPriority.secondary}
      onClick={() => navigateToCart()}
      upgrade
      fullWidth>
      {t('sideCart.goToCartPage.cta')}
    </Button>
  );
};
